module.exports = __webpack_public_path__ + "img/CI.2bbca8a9.png";